import React from 'react';
import Button from 'components/general/Button/Button';
import Icon from 'components/general/Icon/Icon';

const buttonTypes = [
  {
    type: 'prev',
    icon: 'chevron-left',
    show: current => (parseInt(current, 10) !== 1),
    pageQuery: current => (current > 1 ? current - 1 : 1),
  },
  {
    type: 'next',
    icon: 'chevron-right',
    show: (current, pages) => parseInt(current, 10) !== pages,
    pageQuery: (current, pages) => ((current + 1) < pages ? (current + 1) : pages),
  },
];

const Pagination: React.SFC<PaginationPropDef> = ({
  type,
  totalItems,
  perPage,
  currentPage,
  query,
  payload,
}) => {
  // @todo Make this clearer, I don't even remember what is happening.
  const pages = Math.ceil(totalItems / perPage);
  const start = currentPage === 1 ? 1 : ((perPage * (currentPage - 1)) + 1);
  const end = start === 1
    ? ((start + perPage) - 1)
    : ((start + perPage) <= totalItems ? (start + perPage) - 1 : totalItems);

  return (
    <div className="pagination" data-test="pagination">
      <span className="pagination__label">
        {totalItems <= perPage ? (
          <span data-test="pagination-all">Showing all</span>
        ) : (
          <span>
            Showing <strong data-test="pagination-start">{start}</strong>
            –<strong data-test="pagination-end">{end}</strong> of <strong>
            {totalItems}</strong>
          </span>
        )}
      </span>
      <ol className="pagination__nav">
        {buttonTypes.map((btnType) => {
          const btnQuery = Object.assign({}, query, {
            page: btnType.pageQuery(
              currentPage,
              pages,
            ),
          });

          const btnProps = btnType.show(currentPage, pages) ? {
            to: {
              type,
              payload,
              query: btnQuery,
            },
            types: ['xs'],
          } : {
            disabled: true,
            types: ['xs', 'light'],
          };

          return (
            <li
              className="pagination__nav-item"
              key={`pagination-${btnType.type}`}
            >
              <Button {...btnProps}>
                <Icon name={btnType.icon} types={['no-pull']} />
              </Button>
            </li>
          );
        })}
      </ol>
    </div>
  );
};

Pagination.defaultProps = {
  query: {},
};

export interface PaginationPropDef {
  type: string;
  totalItems: number;
  perPage: number;
  currentPage: number;
  query: object;
  payload?: object;
}

export default Pagination;
